module.exports = __webpack_public_path__ + "img/IconCheckWhiteBg.2abe9133.svg";